import { OPERATORS } from 'src/app/services/constants';
import { BandTooltipStrategy } from './band-tooltip-strategy.interface';

export class WyvernBandTooltipStrategy implements BandTooltipStrategy {
  matches(operatorKey: string, operatorMetadata: any, taskSensor: any): boolean {
    console.log('BandOptionTooltipStrategy.matches called with:', { operatorKey, operatorMetadata, taskSensor });
    return operatorKey === OPERATORS.WYVERN && !!taskSensor?.numberOfBands && Array.isArray(operatorMetadata?.band_options);
  }

  buildTooltip(operatorMetadata: any, taskSensor: any): string {
    console.log('BandOptionTooltipStrategy.buildTooltip called with:', { operatorMetadata, taskSensor });
    const normalizedBandCount = `${taskSensor.numberOfBands}`.replace(/\s*Bands?$/i, '').trim();
    const matchingBandOption = operatorMetadata.band_options.find(
      (bandOption: any) => `${bandOption.no_of_bands}`.trim() === normalizedBandCount
    );
    if (!matchingBandOption?.tooltip) return '';
    const normalizedTooltip = matchingBandOption.tooltip.replace(/^\d+\s*bands?:\s*/i, '').trim();
    return `Selected ${normalizedBandCount} bands: ${normalizedTooltip}`;
  }
}
